
export const insertYearBreakTrans = (totalTranAmt, dateValue, savingsClass, totalShareQty, 
       tranSort, yearBreakArr, lastEntry) => {
    
    if (!lastEntry){
        lastEntry = false;
    }
    let nextDateValue = "";
    const tranYear = dateValue;
    dateValue = tranYear + "-12";
    const nextYear = +tranYear + 1;
    nextDateValue = nextYear.toString() + "-01";
    let tranObj = {};
    if (savingsClass === "bank"){
        let tranType = "End of Year Account Balance";
        if (lastEntry === true){
            tranType = "Current Account Balance";
        }
        tranObj = {tranType: tranType,
            tranDate: dateValue,
            tranAmt: totalTranAmt.toFixed(4),
            tranSort: tranSort,
            tranNbr: 9998,
        }
        yearBreakArr.push(tranObj);
        if (lastEntry === false){
            tranObj = {tranType: "Balance Forward",
                tranDate: nextDateValue,
                tranAmt: totalTranAmt.toFixed(4),
                tranSort: tranSort,
                tranNbr: 0,
            }
            yearBreakArr.push(tranObj);
        }
    }else{
        const tranAmt = +totalTranAmt;
        let tranType = "End of Year Account Balance";
        if (lastEntry === true){
            tranType = "Current Account Balance";
        }
        tranObj = {tranType: tranType, 
            tranDate: dateValue,
            shareQuantity: (+totalShareQty).toFixed(4), 
            sharePrice: "",
            tranNbr: 9998, 
            tranSort: tranSort,
            tranAmt: tranAmt,
        }
        yearBreakArr.push(tranObj);
        if (lastEntry === false){
            tranObj = {
                tranType: "Balance Forward", 
                tranDate: nextDateValue,
                shareQuantity: +totalShareQty.toFixed(4), 
                sharePrice: "",
                tranNbr: 0, 
                tranSort: tranSort,
                tranAmt: tranAmt,
            }
            yearBreakArr.push(tranObj);
        }
    }
}
export default insertYearBreakTrans;